@if (theme) {
  <div
    class="breadcrumb-bg {{ theme?.root }} {{ hideOnMobile ? 'hidden md:block' : '' }}"
    [class.tb-border]="border"
    >
    <ul
    class="breadcrumb container list-none py-v-spacing tab:px-v-spacing sm:px-v-spacing
  max-w-container mx-auto flex flex-wrap items-center {{ theme?.container }} "
      >
      @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
        <div>
          <li class="inline text-xs md:text-sm breadcrumb-color">
            @if (breadcrumb.breadcrumbLink) {
              <a
                class="breadcrumb-link underline mr-0.5 md:mr-1 {{ tealLink ? '!text-ace-teal-800' : '' }}"
                href="{{ breadcrumb.breadcrumbLink }}"
                [attr.aria-label]="getAriaLabelLink(breadcrumb.breadcrumbLink, breadcrumb.breadcrumbText)"
                >{{ breadcrumb.breadcrumbText }}</a
                >
              }
              @if (!breadcrumb.breadcrumbLink) {
                <span class="breadcrumb-no-link">{{ breadcrumb.breadcrumbText }}</span>
              }
            </li>
            @if (!last) {
              <span
        class="li-chevron w-4 md:w-5 h-4 md:h-5 text-center inline-block mr-1 md:mr-2 text-xs {{
          tealLink ? '!text-ace-teal-800' : ''
        }}"
                >
                <fa-icon [icon]="faChevronRight"></fa-icon>
              </span>
            }
          </div>
        }
      </ul>
    </div>
  }
